import React from 'react';
import './Tile.css'
// import warning from './warning.png'
import FontIcon from 'material-ui/FontIcon';
// import {LoomisColors} from '../../lib/LoomisColors';
import cn from 'classnames';
import Paper from 'material-ui/Paper';

export const Tile = ({title, data, type, onClick = ()=>{}}) => {

	let statusClass = null;
	let text = '';
	const OnlineIcon = (
        <FontIcon className="material-icons TileIcon">verified_user</FontIcon>
    )
    const WarningsIcon = (
        <FontIcon className="material-icons TileIcon">warning</FontIcon>
    )
    const BalanceIcon = (
        <FontIcon className="material-icons TileIcon">timeline</FontIcon>
    )
    const SalesIcon = (
        <FontIcon className="material-icons TileIcon">store</FontIcon>
    )
    if (type==='online') {
    	text = (
    		<div>{data.online} <span className="OnlineOf">{data.of}</span> <span className="OnlineTotal">{data.total}</span></div>
    		)
    }
    else if (type==='warnings') {
        if (data.problems>0) {
            statusClass = 'RED';
            text = <div>{data.problems} <span className="OnlineOf">{data.in}</span> <span className="OnlineTotal">{data.problemBranches}</span> <span className="OnlineOf">{data.branches}</span></div>
        }
        else {
            onClick = null;
            text = data.problems;
        }

    }
    else {
    	text = data
    }

    return (
        <Paper zDepth={0}>
        <div className={cn(statusClass, 'Tile', type)} onTouchTap={onClick}>
            <div>
				{type === "online" && OnlineIcon}
				{type === "warnings" && WarningsIcon}
				{type === "balance" && BalanceIcon}
				{type === "sales" && SalesIcon}
            </div>
            <div className="TileTitle">{title}</div>
            <div className="TileText">{text}</div>
            </div>
        </Paper>
    );
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/tile/Tile.js